import { staticURL } from 'core/url';
import { Profile } from 'generated/typescript';
import i18next from 'i18next';

export const removeAtSymbol = (str: string): string => str?.replace(/@/g, '');

export const setupProfileForm = (profile: Profile) => {
  const des = 'Tell us about yourself';
  const { username = '', fullName, email } = profile || {};
  const showName = removeAtSymbol(fullName || username || '');

  const extraConfig = { fullName, email, username: removeAtSymbol(username) };

  const fieldsMap: Record<string, any> = {
    fullName: {
      label: i18next.t('Your Name'),
      placeholder: i18next.t('First and Last name'),
      minLen: 3,
      maxLen: 30,
    },
    email: {
      label: i18next.t('Email'),
      validator: 'email',
      placeholder: i18next.t('your@email.com'),
    },
    username: {
      label: i18next.t('Username'),
      fixedValue: '@',
      minLen: 3,
      maxLen: 21,
      placeholder: i18next.t('Type username'),
    },
  };

  // If profile not has email,username and fullName, need add they to form
  const extraFields = Object.keys(extraConfig).reduce(
    (config, key: keyof typeof extraConfig) => {
      return removeAtSymbol(profile?.[key])
        ? config
        : { ...config, [key]: fieldsMap[key] };
    },
    {},
  );

  return {
    setupProfileForm: {
      formTitle: i18next.t('Welcome to Wikifactory'),
      description: i18next.t(showName ? `${des}, ${showName}` : des),
      fields: [
        ...Object.keys(extraFields),
        'job_title',
        'phone',
        'company',
        'company_size',
      ],
      styles: {
        labelBold: true,
      },
      buttonText: i18next.t('Continue'),
      buttonDataTestId: 'confirmProfilePage-form-button',
      buttonHandler: 'createProfile',
    },
    fields: {
      ...extraFields,
      job_title: {
        oneColumn: true,
        label: i18next.t('Job Title'),
        placeholder: i18next.t('Type job title'),
      },
      phone: {
        label: i18next.t('Phone Number'),
        fieldStore: 'forms.PhoneFieldStore',
        component: 'forms.PhoneField',
        placeholder: i18next.t('Type phone number'),
        optional: true,
      },
      company: {
        label: i18next.t('Company'),
        oneColumn: true,
        optional: true,
        placeholder: i18next.t('Type company'),
      },
      company_size: {
        oneColumn: true,
        optional: true,
        label: i18next.t('Company Size'),
        placeholder: i18next.t('Type company size'),
        component: 'forms.TextField',
        fieldStore: 'forms.IntegerFieldStore',
      },
    },
  };
};

export const toSnakeCase = (str: string): string =>
  str.toLowerCase().replace(/\s/g, '_');

export const IndustryTags = [
  {
    label: 'Robotics',
  },
  {
    label: 'Automotive',
  },
  {
    label: 'Industrial',
  },
  {
    label: 'Electronics',
  },
  {
    label: 'Computer Hardware',
  },
  {
    label: 'Medical and Dental',
  },
  {
    label: 'Consumer Products',
  },
  {
    label: 'Energy',
  },
  {
    label: 'Aerospace and Defence',
  },
  {
    label: 'Machine Building',
  },
  {
    label: 'Machinery Equipment',
  },
  {
    label: 'Education',
  },
  {
    label: 'R&D',
  },
  {
    label: 'Other',
  },
].map(item => ({
  ...item,
  value: toSnakeCase(item.label),
  src: staticURL(`assets/icons/${toSnakeCase(item.label)}.svg`),
}));

export const UsingWikiReasons = [
  {
    label: 'Cloud PDM',
  },
  {
    label: 'Team Collaboration',
  },
  {
    label: 'CAD File Conversion',
  },
  {
    label: 'Online Manufacturing',
  },
  {
    label: 'CAD Visualisation',
  },
  {
    label: 'CAD Data Management',
  },
  {
    label: 'Online Repository',
  },
  {
    label: 'Consumer Products',
  },
  {
    label: 'File Syncing',
  },
  {
    label: 'Stakeholder Management',
  },
  {
    label: 'Public Projects',
  },
  {
    label: 'Community',
  },
  {
    label: 'Educational Resources',
  },
].map(item => ({
  ...item,
  value: toSnakeCase(item.label),
}));
